<template>
  <path
    d="M12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM10 16.0002C9.45 16.0002 9 15.5502 9 15.0002V9.00018C9 8.45018 9.45 8.00018 10 8.00018C10.55 8.00018 11 8.45018 11 9.00018V15.0002C11 15.5502 10.55 16.0002 10 16.0002ZM14 16.0002C13.45 16.0002 13 15.5502 13 15.0002V9.00018C13 8.45018 13.45 8.00018 14 8.00018C14.55 8.00018 15 8.45018 15 9.00018V15.0002C15 15.5502 14.55 16.0002 14 16.0002Z"
  />
</template>
